import Hyphenator from 'exports-loader?Hyphenator!hyphenator.js/Hyphenator';
import HyphenatorDe from 'exports-loader?Hyphenator.languages.de!imports-loader?Hyphenator=>{languages:{}}!hyphenator.js/patterns/de';
import HyphenatorEn from 'exports-loader?Hyphenator.languages["en-gb"]!imports-loader?Hyphenator=>{languages:{}}!hyphenator.js/patterns/en-gb';
import HyphenatorIt from 'exports-loader?Hyphenator.languages["it"]!imports-loader?Hyphenator=>{languages:{}}!hyphenator.js/patterns/it';

Hyphenator.languages['de'] = HyphenatorDe;
Hyphenator.languages['en'] = HyphenatorEn;
Hyphenator.languages['it'] = HyphenatorIt;

if (document.documentElement.lang !== 'rm') {
  Hyphenator.config({ remoteloading: false });
  window.Hyphenator = Hyphenator;
  Hyphenator.run();
}
